import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

/**
 * StepShell — glass/morphism card that wraps each wizard block and animates
 * its enter/exit transition. Rendered inside an <AnimatePresence mode="wait">
 * keyed by the active step id.
 */
const variants = {
  initial: { opacity: 0, x: 24 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -24 },
};

export default function StepShell({ title, description, children, className }) {
  return (
    <motion.section
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.28, ease: [0.16, 1, 0.3, 1] }}
      className={cn("tw-glass rounded-[24px] p-6 sm:p-8", className)}
    >
      {title && (
        <header className="mb-6">
          <h2 className="text-2xl font-semibold tracking-tight text-foreground">
            {title}
          </h2>
          {description && (
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-muted-foreground">
              {description}
            </p>
          )}
        </header>
      )}
      {children}
    </motion.section>
  );
}
